import { Component, Input, ViewEncapsulation, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { element } from 'protractor';

import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
//import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormGroupName} from '@angular/forms';
import { ValidationFormsService } from './validation-forms.service';
import { ValidatorFn, ValidationErrors } from '@angular/forms';
import { ToasterComponent, ToasterPosition } from '@coreui/angular';
import { AppToastComponent as ToastComp } from '../../../services/shared-service/toast-simple/toast.component'
import { HttpService } from '../../../services/http-service/http.service'
import { ValidationService } from '../../../services/validation-service/validation.service';

import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '../../../services/storege-service/storage.service';
import * as moment from 'moment';
import { ToolService } from '../../../services/tool/tool.service';

@Component({
  //selector: 'app-toasters',
  templateUrl: './basic-forms.component.html',
  styleUrls: ["../../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css",],
  encapsulation: ViewEncapsulation.None,
  providers: [ ValidationFormsService ]
})


export class BasicFormsComponent {


  minDate = new Date(2017, 5, 10);
  maxDate = new Date(2022, 9, 15);

  bsValue: Date = new Date();

// Timepicker

  public isEnabled: boolean = true;


  public mfData? : object = {};
  public promotionConfigList?;
  public users?;
  isUpdate: boolean = false;
  dbFunction?: string;
  promotionConfigurationId?: string;
  description: string;
  customerCountryCode: string;
  customerMobile: string;
  code: string;
  noOfUses: string;
  percentage: string;
  notes: string;
  used: string;
  onUs: string;
  status: string;
  public facilityId = '';
  public isLoading = false;
  expiryDate: string;

  isError: boolean = false;

  simpleForm: FormGroup;
  submitted = false;
  formErrors: any;

  @ViewChild(ToastComp) toastComp: ToastComp;

  public paddingStyle: Object = { 'padding-right': '20px'};


  constructor(
    private router: Router, 
    private http: HttpClient, 
    public route: ActivatedRoute,
    private fb: FormBuilder,
    public vf: ValidationFormsService, 
    public httpService: HttpService,
    private toastr: ToastrService,
    private localInterfaceSrv: LocalInterfaceService,
    private storageSrv: StorageService,
    private validationSrv : ValidationService,
    public toolService: ToolService,
    ) {
    if (localStorage.getItem('lang') === "ar") {
    }
    this.formErrors = this.vf.errorMessages;
    this.facilityId = this.storageSrv.getFacilityId();

    if(this.router.getCurrentNavigation().extras.state?.createData == null)
    {
      this.isUpdate = true;
      this.mfData = this.router.getCurrentNavigation().extras.state?.data;
      this.promotionConfigurationId = this.mfData['promotionConfigurationId'];
      this.description = this.mfData['description'];
      this.customerCountryCode = this.mfData['customerCountryCode'];
      this.customerMobile = this.mfData['customerMobile'];
      this.code = this.mfData['code'];
      this.noOfUses = this.mfData['noOfUses'];
      this.percentage = this.mfData['percentage'];
      this.notes = this.mfData['notes'];
      this.used = this.mfData['used'] == '1' ? 'Yes' : 'No';
      this.expiryDate = this.mfData['expiryDate'] != null ? new Date(this.mfData['expiryDate'].replace(/-/g, "/")) : this.mfData['expiryDate'];
      this.onUs = this.mfData['onUs'];
      this.status = this.mfData['status'];
    }
    else
    {
      this.promotionConfigurationId = this.promotionConfigurationId == null ? null : this.promotionConfigurationId;
      this.description = '';
      this.customerCountryCode = '973';
      this.customerMobile = '';
      this.code = '';
      this.noOfUses = '';
      this.percentage = '';
      this.notes = '';
      this.used = '';
      this.expiryDate = '';
      this.onUs = '';
      this.status = '';
    }
    this.createForm();
  }

  isCollapsed: boolean = false;
  iconCollapse: string = 'icon-arrow-up';

  @Input() message : string;
  messages: string[] = [];
  updatedData = this.mfData;

  // Validators.pattern('^[0-9]{4}[\/][1-9]|1[012][\/][0-9]{2}$')]
  createForm() {
    this.simpleForm = this.fb.group({
      promotionConfigurationId: [this.promotionConfigurationId],
      description: [this.description, [Validators.required]],
      customerCountryCode: [this.customerCountryCode, [Validators.required]],
      customerMobile: [this.customerMobile, [Validators.required]],
      code: [this.code, [Validators.required]],
      noOfUses: [this.noOfUses, [Validators.required]],
      percentage: [this.percentage],
      notes: [this.notes],
      used: {value: this.used, disabled: true},
      expiryDate: [this.expiryDate, [Validators.required]],
      onUs: [this.onUs],
      status: [this.status],
    }, { });
  }
  get f() { return this.simpleForm.controls; }

  loadPromotionConfig = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getPromotionConfig(facilityId)
      .then(res => {
        this.promotionConfigList = res;
        this.isLoading = false;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
      })
      .finally(() => {this.updatePromotionConfigList(); this.isLoading = false; });
    });
  }

  ngOnInit(): void {
    this.validationSrv.validateAcess()
    .then(async () => {
      this.isLoading = true;
      this.route.queryParams.subscribe(async params => {
        this.facilityId = this.storageSrv.getFacilityId();
        await this.loadPromotionConfig(this.facilityId);
        //await this.updateCourtId(this.court);
        await this.createForm();
        await this.updatePromotionConfigList();
      });
    })
    .finally(() => {this.updatePromotionConfigList(); this.isLoading = false; });
  }

  async showSuccess(msg) 
  {
    await this.toastr.success(msg, 'Success');
    if (this.isUpdate && !this.isError)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {

        });;
      });  
    }
    else if (!this.isUpdate && this.isError == false)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
        });;
      });  
    }
  }

  showError(msg) {
    //this.toasterService.pop('error', 'Error', msg);
  }

  async updatePromotionConfigList()
  {
    this.f['promotionConfigurationId'].disable();
    if (this.isUpdate)
    {
      this.f['customerCountryCode'].disable();
      this.f['customerMobile'].disable();
    }
    else
    {
      this.f['percentage'].enable();
    }
    var selectedId = this.f['promotionConfigurationId'].value;
    if (selectedId === null && !this.isUpdate)
    {
      this.f['customerCountryCode'].enable();
      this.f['customerMobile'].enable();
      this.f['percentage'].enable();
    }
    else
    {
      this.f['percentage'].disable();
    }
  }
  public showPayment()
  {
    //this.router.navigate(['facility'], {state: {data: ''}, relativeTo: this.route});
    // if (this.editFlag == true)
    // {
    //   this.editFlag = false;
    // }
    // if (this.editFlag == false)
    // {
    //   this.editFlag = true;
    // }
    // this.myDivRef.nativeElement.scrollIntoView({behavior: "smooth", block: "start" });
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.simpleForm.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
}


savePromotion = () => {
  return new Promise<any>(async (resolve, reject) => {
    this.isLoading = true;
    let formattedExpiryDate = (moment(new Date(this.f['expiryDate'].value))).format('YYYY-MM-DD');

    const fields = {
      promotionId: this.mfData['id'],
      staffId: this.storageSrv.getUser(),
      promotionConfigurationId: this.f['promotionConfigurationId'].value,
      facilityId: this.facilityId,
      description: this.f['description'].value,
      code: this.f['code'].value,
      noOfUses: this.f['noOfUses'].value,
      percentage: this.f['percentage'].value,
      notes: this.f['notes'].value,
      expiryDate: formattedExpiryDate,
      onUs: this.f['onUs'].value,
      status: this.f['status'].value,
    };
    if (this.isUpdate) 
    {
      this.localInterfaceSrv.updatePromotionAdmin(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('Promotion Updated');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.desc, "Error");
      })
      .finally(() => this.isLoading = false);
    } 
    else 
    {
      this.localInterfaceSrv.addPromotionAdmin(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('Promotion Added');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.desc, "Error");
      })
      .finally(() => this.isLoading = false);
    }
  });
}

  async delay(ms: number) {
    //await new Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>this.toolService.showConsoleLog("fired"));
}

  collapsed(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  updateData(name: string): void {
    this.updateData['nameEn'] = name;
  }
 

  expanded(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.iconCollapse = this.isCollapsed ? 'icon-arrow-down' : 'icon-arrow-up';
  }
}
